import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconHook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHook"><Circle cx="9.5" cy="5.5" r="3" stroke="currentColor"/><Path d="M9.5 9V18C9.5 19.933 11.067 21.5 13 21.5C14.933 21.5 16.5 19.933 16.5 18V11.5L13.5 14.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconHook;
